module.exports = __webpack_public_path__ + "img/salesProduct.a65d4055.png";